import EAHeader from "./Header";
import ListData from "./ListData";
import TableData from "./TableData";

const securityEAComponents = {
  ListData,
  TableData,
  EAHeader
}

export default securityEAComponents